<template>
  <div class="project-add">
    <el-form ref="form" :model="addForm" label-width="100px" size="mini" label-position="left" :rules="addFormRules">
      <base-info :baseForm="addForm"></base-info>

      <div class="body">
        <detail-info :detailForm="addForm"></detail-info>

        <div class="commit-box">
          <el-button class="save-btn" @click="save('0')">保存</el-button>
          <el-button class="commit-btn" @click="commit">提交</el-button>
        </div>
      </div>
    </el-form>
    <!-- <search-box @getResult="getSearchResult" ref='searchBox' title="审批人搜索"></search-box> -->
    <select-user @getResult="getSearchResult" @close='selectShow = false' title="添加处理人" :show='selectShow'></select-user>

  </div>
</template>

<script>
import moment from 'moment'

import * as projectApi from '../../api/projectAPI'
import commonData from '../../common/commonData'
import detailInfo from '../subcomponents/project_detail_info.vue'
import baseInfo from '../subcomponents/project_base_info.vue'
import selectUser from '../subcomponents/select_user.vue'
export default {
  name: 'addProject',
  data() {

    return {
      addForm: {
        name: "",
        code: "",
        approverId: 0,
        tripList: [{}],
        dateArr: [],
        approver: {}
      },
      userInfo: {},
      addFormRules: {},
      selectShow: false,
      timer: '',
      projectId: '',
      detailId: ''

    }
  },
  async created() {
    this.addFormRules = commonData.projectFormRules
    this.userInfo = await this.$store.getters.getUserInfo

    //console.log(commonData);

    await this.qryProject()
    this.addForm.empName = this.userInfo.username
    this.addForm.linkPhone = this.userInfo.mobile
    this.addForm.empId = this.userInfo.id
    this.$nextTick(() => {
      // DOM 更新了
      console.log("dom update complete")
      this.$refs["form"].clearValidate()
    })
    this.timer = setInterval(async () => { await this.autoSave() }, 30000);

  },
  async moment() {
    // this.$set(this,'addFormRules',commonData.projectFormRules)

  },
  methods: {
    async qryProject() {

      let res = await projectApi.qrySavedProject()
      if (res.flag) {
        this.projectId = res.data.project.id
        this.detailId = res.data.detail.id
        this.addForm = { ...res.data.detail, ...res.data.project }
        let pattern = 'YYYY-MM-DD HH:mm:ss'
        this.addForm.trainDate = [moment(res.data.detail.trainStartTime).format(pattern), moment(res.data.detail.trainEndTime).format(pattern)]
        this.addForm.summaryDate = [moment(res.data.detail.summaryStartTime).format(pattern), moment(res.data.detail.summaryEndTime).format(pattern)]
        this.addForm.surveyDate = [moment(res.data.detail.surveyStartTime).format(pattern), moment(res.data.detail.surveyEndTime).format(pattern)]
      }
    },



    async validate() {
      let flag = true
      await this.$refs.form.validate(async (valid, rules) => {
        if (!valid) {
          for (const key in rules) {
            flag = false;
            console.log(key, rules[key][0].message)
            this.$message.error(rules[key][0].message)
            throw Error(rules[key][0].message)
          }
          return
        }
      })
      if (!flag) {
        throw Error('校验失败')
      }
    },
    async autoSave() {
      let param = { ...this.addForm }
      param.state = '0'
      let map = { project: param, detail: param, approver: param.approver }
      map.cancelLoading = true
      delete map.detail.approver
      if (this.projectId) {
        map.project.id = this.projectId
      }
      if (Object.keys(map.detail).length && this.detailId) {
        map.detail.id = this.detailId
      }
      let res = await projectApi.create(map)
      if (res.flag) {
        this.projectId = res.data[0]
        this.detailId = res.data[1]
      }


    },
    async save(state) {
      // await this.validate()
      let param = { ...this.addForm }
      // let dateArr = param.trainDate || []
      // let dateArr2 = param.summaryDate || []
      // if (dateArr.length == 2) {
      //   param.trainStartTime = dateArr[0]
      //   param.trainEndTime = dateArr[1]
      // }
      // if (dateArr2.length == 2) {
      //   param.summaryStartTime = dateArr2[0]
      //   param.summaryEndTime = dateArr2[1]
      // }
      param.state = state
      let map = { project: param, detail: param, approver: param.approver }
      delete map.detail.approver
      if (this.projectId) {
        map.project.id = this.projectId
      }
      if (Object.keys(map.detail).length && this.detailId) {
        map.detail.id = this.detailId
      }
      console.log("save", map);
      let res = await projectApi.create(map)
      if (res.flag) {
        this.$message.success('项目' + (state == 1 ? '提交' : '保存') + '成功')
        if (state == 1) {
          this.$router.push({ path: '/projectlist' })
        }
      }

      // let res = await projectApi.create(map)
      // if (res.flag) {
      //   this.$message.success('项目' + (state == 1 ? '提交' : '保存') + '成功')
      //   this.$router.push({ path: '/projectlist' })
      // }
    },

    async commit() {
      await this.validate()
      console.log("commit");
      // this.$refs.searchBox.innerVisible = true
      this.selectShow = true
    },
    async getSearchResult(data) {
      console.log("getSearchResult", data);
      this.addForm.approver = {}
      this.addForm.approver.id = data.id
      this.addForm.approver.name = data.name
      this.selectShow = false
      this.$confirm('确认提交该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.save('1')
      })

    }

  },
  computed: {


  },
  watch: {

  },
  components: {
    'detail-info': detailInfo,
    'base-info': baseInfo,
    'select-user': selectUser
  },

  beforeDestroy() {

    clearInterval(this.timer);

  }
}
</script>

<style lang="less"  >
.project-add {
  .body {
    border-radius: 10px;
    margin-top: 20px;
    background: #fff;
    .commit-box {
      text-align: center;
      padding-top: 0;
      .commit-btn {
        font-size: 16px;
        width: 300px;
        color: #fff;
        background: #3b63ff;
        border-radius: 10px;
        border: none;
      }
      .save-btn {
        border-radius: 10px;
        margin-left: 40px;
        font-size: 16px;
        width: 300px;
        color: #fff;
        background: #a6aab8;
        border: none;
      }
    }
  }
}
</style>
